module.exports = __webpack_public_path__ + "static/how_it_works_practice_art@2x-cc83e0452463c75232549074edc8df69.png";